import { backend_client } from "../../../helpers/api";

const getAdminReportService = (examInstaceId) => {
  const endpoint = `/exam-instances/${examInstaceId}/admin-report`;
  return backend_client.get(endpoint);
};

export default getAdminReportService;
